import OfferSliderCard from './OfferSliderCard'

export default {
  name: 'OfferSliderMultiple',
  components: { OfferSliderCard },
  template: `
    <div class="swiper">
      <div class="swiper-wrapper">
        <div v-for="(offer, index) in offers" class="swiper-slide">
          <OfferSliderCard :offer="offer" :buttonText="buttonText" :extraClasses="extraClasses" />
        </div>
        <div class="swiper-slide" v-if="bigCardSlider">&nbsp;</div>
      </div>
      <div :class="bigCardSlider ? 'big-card-slider__navigation' : 'card-slider__navigation'">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="swiper-scrollbar" v-if="bigCardSlider"></div>
  `,
  props: { offers: Array, bigCardSlider: Boolean, buttonText: String, extraClasses: Array },
}
